import { exit } from '../../stores/actions/actions';
import EmptyCard from "../../components/EmptyCard/EmptyCard.jsx";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import React from "react";
import { connect } from 'react-redux';
import { pollSystems } from '../../stores/actions/pollingActions';
import { getSystems2 } from '../../stores/actions/actions';
import ErrorText from '../../components/ErrorComponent/ErrorText';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import SystemSearchBar from '../../components/SystemSearchBar/SystemSearchBar'
import ShortStatusContet from '../../components/ShortStatus/ShortStatusContet';
import MapLoading from '../Dashboard/MapLoading';

class DashboardSystems extends React.Component {
  constructor(props) {
    super(props);

    this.renderEmptyMessage = this.renderEmptyMessage.bind(this);
    this.props.getSystems2();
  }

  renderSystemSearchBar = () => {
    if (!this.props.systems.length) return null;
    return <SystemSearchBar />
  }
  renderEmptyMessage = () => {
    return <MapLoading testID="systemsLoaderContainer" />;
  }

  render() {
    //Redirect if only one system 
    const { classes, mobileView } = this.props;

    try {
      let content;
      const { dashboardFilteredSystemsNames, systems } = this.props;

      if (systems.length >= 1) {
        content = systems.map((system, i) => {
          const filteredSystem = dashboardFilteredSystemsNames.find(filteredSystem => filteredSystem === system.name)
          if (!filteredSystem && dashboardFilteredSystemsNames.length) return null;
          return (
            <GridItem
              xs={12}
              sm={6}
              md={4}
              lg={4}
              key={"grid-item-" + i}
              style={{ padding: mobileView ? '0 15px;' : (i+2)%3 ? '0 15px' : '0 7px'}}
            >
              <ShortStatusContet
                linkDisabled={false}
                key={i + "-short-status"}
                classes={classes}
                system={system}
                showSmallWeatherCard={true}
              />
            </GridItem>
          )
        });
      } else {
        content = this.renderEmptyMessage()
      }

      return (
        <ErrorComponent message='Corrupted systems data.' children>
          <GridContainer data-testid="DashboardSystems">
            {this.renderSystemSearchBar()}
            {content}
          </GridContainer>
        </ErrorComponent>
      );
    } catch (error) {
      console.log(error)
      return (
        <ErrorText message='Corrupted systems data.'></ErrorText>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    systems: state.dashboard.systems,
    accountCategory: state.dashboard.accountCategory,
    dashboardFilteredSystems: state.dashboard.dashboardFilteredSystems,
    dashboardFilteredSystemsNames: state.dashboard.dashboardFilteredSystemsNames,
    mobileView: state.dashboard.mobileView
  }
}
const actions = {
  exit,
  pollSystems,
  getSystems2,
}

export default connect(mapStateToProps, actions)(DashboardSystems);